import React, { useContext } from 'react';
import { LocalizationGroup } from './components/LocalizationGroup';
import { IWordingsContext, WordingsContext } from '../../../wordingsState/wordingsContext';
import style from './InputFields.module.scss';

interface IInputFields {
	languageId: string;
}

const InputFields: React.FC<IInputFields> = ({ languageId }) => {
	const { groups } = useContext<IWordingsContext>(WordingsContext);

	return (
		<div className={style.container}>
			{groups.map((el) => (
				<LocalizationGroup key={el.id} isRequired={true} languageId={languageId} groupData={el} />
			))}
		</div>
	);
};

export default InputFields;
